import { useSeo } from './useSeo';
import { watch } from 'vue';
import { useRoute } from 'vue-router';

/**
 * Watch for language changes in i18n and update SEO tags accordingly
 * Use this in App.vue or main layout component
 */
export function useSeoLanguageSync(i18n) {
  const route = useRoute();
  // Watch i18n locale changes
  watch(
    () => i18n.locale.value,
    (newLang) => {
      localStorage.setItem('language', newLang);
      // Update SEO tags with CURRENT language
      useSeo({}, newLang);
      // Update HTML lang and dir attributes
      document.documentElement.lang = newLang;
      document.documentElement.dir = newLang === 'ar' ? 'rtl' : 'ltr';
    },
    { 
      immediate: true,
      flush: 'post',
      deep: true
    }
  );

  // Watch route changes
  watch(
    () => route.path,
    () => {
      const lang = i18n.locale.value;
      useSeo({}, lang);
    },
    {
      immediate: true
    }
  );
}
